module.exports = {"fb_lang":"en_IN","mapCenter":{"lat":"13.0475226","lng":"80.0685804"},"geocomplete_country":"in","PHONE_REGEX":"^\\d{10}$","EMAIL_REGEX":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}","en-IN":{"blank_field":"Please fill out this field.","incorrect_email":"Please enter a valid email address.","error_message_signup_email_used":"has already registered","error_message_signup_phone_taken":"has already been taken"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/in/scripts/components/setting.json
// module id = 855
// module chunks = 0 1 2 3 4 5